import {
  Box,
  Button,
  Card,
  Typography,
  styled,
} from "@mui/material";
import { COLORS } from "../utils/colors";

/**
 * Typography with gradient background
 */
export const GradientTypography = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryLight} 100%)`,
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  color: "transparent",
  display: "inline",
}));

/**
 * Button with gradient background
 */
export const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryLight} 100%)`,
  color: "white",
  borderRadius: "50px",
  padding: theme.spacing(1, 3),
  textTransform: "none",
  fontWeight: 600,
  "&:hover": {
    background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.primaryLight} 100%)`,
    opacity: 0.9,
    boxShadow: theme.shadows[4],
  },
}));

/**
 * Button with outline
 */
export const OutlineButton = styled(Button)(({ theme }) => ({
  borderRadius: "50px",
  border: `1px solid ${COLORS.primary}`,
  color: COLORS.dark,
  padding: theme.spacing(1, 3),
  textTransform: "none",
  fontWeight: 600,
  "&:hover": {
    backgroundColor: `rgba(${parseInt(COLORS.primary.slice(1, 3), 16)}, ${parseInt(COLORS.primary.slice(3, 5), 16)}, ${parseInt(COLORS.primary.slice(5, 7), 16)}, 0.05)`,
  },
}));

/**
 * Card with hover effect
 */
export const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  borderRadius: theme.spacing(2),
  backgroundColor: COLORS.light,
  boxShadow: theme.shadows[2],
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: theme.shadows[6],
  },
}));

/**
 * Box with floating animation
 */
export const FloatingBox = styled(Box)(({ theme }) => ({
  "@keyframes float": {
    "0%, 100%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-10px)" },
  },
  animation: "float 6s ease-in-out infinite",
}));

/**
 * Image with responsive sizing
 */
export const AppImage = styled("img")(({ theme }) => ({
  maxWidth: "95%",
  display: "block",
  margin: "0 auto",
}));

/**
 * Image with hover effect
 */
export const HoverImage = styled("img")(({ theme, height = 48 }: any) => ({
  height: height,
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "translateY(-5px)",
  },
}));

/**
 * Section container with standard padding
 */
export const Section = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(12, 0),
  },
}));

/**
 * Hero section with gradient background
 */
export const HeroSection = styled(Section)(({ theme }) => ({
  background: `linear-gradient(135deg, ${COLORS.light} 0%, #f5f5f5 100%)`,
  textAlign: "center",
}));

/**
 * Feature section with alternating background
 */
export const FeatureSection = styled(Section)(({ theme, index }: any) => ({
  background: index % 2 === 0 ? COLORS.light : "#f5f5f5",
}));